<template></template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";

let resizeObserver: ResizeObserver | null = null;
let headerElement: HTMLElement | null = null;

const updateBoundTop = (rect: DOMRectReadOnly) => {
  const boundTop = rect.bottom;
  document.body.style.setProperty("--bound-top", `${boundTop}px`);
};

const initObserver = () => {
  headerElement = document.getElementById("header");

  if (!headerElement) {
    // Retry if header is not yet available
    setTimeout(initObserver, 100);
    return;
  }

  resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target instanceof HTMLElement) {
        updateBoundTop(entry.contentRect);
      }
    }
  });

  resizeObserver.observe(headerElement);
};

onMounted(() => {
  // Use nextTick to ensure DOM is ready
  setTimeout(initObserver, 0);
});

onUnmounted(() => {
  if (resizeObserver && headerElement) {
    resizeObserver.unobserve(headerElement);
    resizeObserver.disconnect();
    resizeObserver = null;
  }
  headerElement = null;
});
</script>
